import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MeteringPointsState } from '@appStore/metering-points';
import { CustomersState } from '@appStore/customers';
import { AccountState } from '@appStore/account';
import { MeteringFilterType } from '@enums';
import { MeteringPoint, MeteringPointGroup, MeteringFilter, SelfServiceAgreement } from '@model';
import { ConfigurationState } from '@appStore/configuration';

const getMeteringPointFeatureState = createFeatureSelector<MeteringPointsState>('meteringpoints');
const getMeteringPointsState = createSelector(
  getMeteringPointFeatureState,
  state => state.meteringPoints
);
const getMeteringPointGroupsState = createSelector(
  getMeteringPointFeatureState,
  state => state.meteringPointGroups
);

const getSettingFeatureState = createFeatureSelector<AccountState>('account');
const getUserDataState = createSelector(
  getSettingFeatureState,
  state => state.userinfo
);
const getSettingsState = createSelector(
  getSettingFeatureState,
  state => state.settings
);
// const getAgreementsState = createSelector(
//   getSettingFeatureState,
//   state => state.agreements
// );

const getConfigurationFeatureState = createFeatureSelector<ConfigurationState>('configuration');
const getConfigurationState = createSelector(
  getConfigurationFeatureState,
  state => state.configuration
);

const getCustomerFeatureState = createFeatureSelector<CustomersState>('customers');
const gettCustomersState = createSelector(
  getCustomerFeatureState,
  state => state.customers
);

export const getFilledSettingsDataLoaded = createSelector(
  getMeteringPointsState,
  getMeteringPointGroupsState,
  getSettingsState,
  (mpState, mpgState, sState) => {
    return mpState.loaded && mpgState.loaded && sState.loaded;
  }
);

export const getIsAuthorizedAndPermissionsLoaded = createSelector(
  getUserDataState,
  getConfigurationState,
  (userData, configuration) => {
    return userData.isauthorized && configuration.permissionsLoaded;
  }
);

// export const getFilledSelfServiceFormsDataLoaded = createSelector(
//   getMeteringPointsState,
//   gettCustomersState,
//   getAgreementsState,
//   (mpState, cState, aState) => {
//     return mpState.loaded && cState.loaded && aState.selfServiceAgreementsLoaded;
//   }
// );


// export const getFilledSelfServiceForms = createSelector(
//   getMeteringPointsState,
//   gettCustomersState,
//   getAgreementsState,
//   (mpState, cState, aState) => {
//     const meteringPoints = mpState.data;
//     const customers = cState.data;
//     const agreements = aState.selfServiceAgreements;

//     if (agreements.length > 0 ) {
//       const filledSelfServiceAgreements = [] as SelfServiceAgreement[];

//       agreements.forEach(agreement => {

//         let meteringpoint = meteringPoints.find(m => m.id.toString() === agreement.meteringPointId);
//         let customer = customers.find(c => c.id === agreement.customerId);
      
//         const data: SelfServiceAgreement = {
//           id: agreement.id,
//           userId: agreement.userId,
//           name: agreement.name,
//           meteringPointId: agreement.meteringPointId,
//           meteringPointName: meteringpoint ?  meteringpoint.name : '',
//           customerId: agreement.customerId,
//           signedDate: agreement.signedDate,
//           itemId: agreement.itemId,
//           signedState: agreement.signedState,
//           customerName: customer ? customer.name : ''
//         };

//         filledSelfServiceAgreements.push(data);
//       });
//       return sortByProperty(filledSelfServiceAgreements, 'signedDate');
//     } else {
//       return [];
//     }
//   });

  export function sortByProperty(collection, property: string) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
  
    return collection.sort(function(a, b) {
      const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    });
  }

export const getFilledSettings = createSelector(
  getMeteringPointsState,
  getMeteringPointGroupsState,
  getSettingsState,
  (mpState, mpgState, sState) => {
    const meteringPoints = mpState.data;
    const meteringPointGroups = mpgState.data;
    let settings = sState.data;

    if (meteringPoints.length === 0 || !settings) {
      return settings;
    }

    if (settings.hotMeteringFilter) {
      settings = {
        ...settings,
        hotMeteringFilter: fillMeteringPointName(settings.hotMeteringFilter, meteringPoints, meteringPointGroups)
      };
    }

    if (settings.coldMeteringFilter) {
      settings = {
        ...settings,
        coldMeteringFilter: fillMeteringPointName(settings.coldMeteringFilter, meteringPoints, meteringPointGroups)
      };
    }

    return settings;
  }
);

function fillMeteringPointName(
  filter: MeteringFilter,
  meteringPoints: MeteringPoint[],
  meteringPointGroups: MeteringPointGroup[]
): MeteringFilter {
  switch (filter.filterType) {
    case MeteringFilterType.MeteringPoint:
      const meteringPoint = meteringPoints.filter(mp => mp.id === filter.filterId);
      if (meteringPoint.length > 0) {
        filter = {
          ...filter,
          name: meteringPoint[0].name,
          containsMeteringPointIds: [meteringPoint[0].id]
        };
      }
      return filter;

    case MeteringFilterType.VirtualFilter:
      filter = {
        ...filter,
        name: 'Valda anläggningar',
        subtitle: filter.containsMeteringPointIds.length + ''
      };
      return filter;

    case MeteringFilterType.MeteringPointGroup:
      if (meteringPointGroups.length === 0) {
        return filter;
      }
      const meteringPointGroup = meteringPointGroups.filter(mpg => mpg.id === filter.filterId);
      if (meteringPointGroup.length > 0) {
        let mpIds = meteringPointGroup[0].meteringPoints.map(mp => mp.id);
        filter = {
          ...filter,
          name: meteringPointGroup[0].name,
          containsMeteringPointIds: mpIds,
          subtitle: meteringPointGroup[0].meteringPoints.length + ''
        };
      }
      return filter;
  }

  return filter;
}
